module.exports = __webpack_public_path__ + "static/media/so-icon__hooves.893cc538.svg";